<template>
  <div class="review-maps" ref="reviewMapsBox">
    <div id="matching">
      <div
        class="matching-content"
        @touchstart.stop.prevent="touchstart"
        @touchmove.stop.prevent="touchmove"
        @touchend.stop.prevent="touchend"
      >
        <div class="matching-top marching-item-top marching-item">
          <span
            class="item"
            v-for="(item, index) in matching.top"
            :key="index"
            @mousedown.stop.prevent="mousedown([0, index])"
            @mouseup.stop.prevent="mouseup([0, index])"
          >{{ item.title }}</span>
        </div>
        <div class="matching-gap"></div>
        <div class="marching-item-bottom marching-item">
          <span
            class="item"
            v-for="(item, index) in matching.bottom"
            :key="index"
            @mousedown.stop.prevent="mousedown([1, index])"
            @mouseup.stop.prevent="mouseup([1, index])"
          >{{ item.title }}</span>
        </div>
      </div>
      <canvas class="backcanvas" id="backcanvas"></canvas>
    </div>
    <PageLoading :active="showLoading" />
  </div>
</template>
<script>
import ReviewHttp from "../review";
import VerticalScrollbox from "@/components/VerticalScrollbox";
import PageLoading from "@/components/Loading";

const JIAN_XI_H = 35; // 横向 间隙
const JIAN_XI_V = 200; // 横向 间隙
const ITEM_HEIGHT = 70; // 高度
export default {
  name: "review-map",
  data() {
    return {
      showLoading: false,
      canvas: null,

      matching: {
        top: [
          { title: "1", id: "1" },
          { title: "2", id: "2" },
          { title: "3", id: "3" },
          { title: "3", id: "4" }
        ],
        bottom: [
          { title: "4", id: "1" },
          { title: "5 ", id: "2" },
          { title: "6", id: "3" },
          { title: "6", id: "4" }
        ]
      },

      clickItem: false,
      isMoving: false, // 移动端 移动中

      // 存储 画的所有线
      drawList: [],
      // 正在画的线
      currentDraw: {
        curFromOrigin: -1,
        drawFrom: [],
        drawTo: [],
        startIndex: -1,
        endIndex: -1,
        start: {
          x: 0,
          y: 0
        },
        end: {
          x: 0,
          y: 0
        }
      }
    };
  },
  components: {
    PageLoading
  },
  created() {
    this.student_id = this.$store.state.currentChild.student_id;
    this.id = this.$route.query.id;
    // this.showLoading = true;
  },
  mounted() {
    this.init();

    document.addEventListener(
      "mousedown",
      () => {
        this.clickItem = false;
      },
      false
    );
    document.addEventListener(
      "mouseup",
      () => {
        this.clickItem = false;
        console.log("mouseup");
        this.currentDraw.start.x = 0;
        this.currentDraw.start.y = 0;
        this.currentDraw.end.x = 0;
        this.currentDraw.end.y = 0;
        this.currentDraw.startIndex = -1;
        this.currentDraw.endIndex = -1;
        this.repainCanvas();
      },
      false
    );
    document.addEventListener(
      "touchend",
      () => {
        this.clickItem = false;
        console.log("mouseup");
        this.currentDraw.start.x = 0;
        this.currentDraw.start.y = 0;
        this.currentDraw.end.x = 0;
        this.currentDraw.end.y = 0;
        this.currentDraw.startIndex = -1;
        this.currentDraw.endIndex = -1;

        this.from = -1;
        this.endFrom = -1;
        this.startIndex = -1;
        this.endIndex = -1;
        this.isMoving = false;
        this.repainCanvas();
      },
      false
    );
  },
  watch: {},
  methods: {
    repainCanvas() {
      this.clearCanvas();
      this.drawList.forEach(e => {
        this.strockline(e.points);
      });
    },
    dragstart() {
      return false;
    },

    touchstart(e) {
      let canMove = false;

      this.isMoving = false;
      this.from = -1; // 0 上， 1 下
      this.startIndex = -1; // 开始 的 下标

      console.log(e.touches[0]);
      let curCoordinate = e.touches[0];
      this.coordinatesList.top.forEach((e, i) => {
        if (
          e.x1 < curCoordinate.pageX &&
          e.x2 > curCoordinate.pageX &&
          e.y1 < curCoordinate.pageY &&
          e.y2 > curCoordinate.pageY
        ) {
          canMove = true;
          this.from = 0;
          this.startIndex = i;
          console.log("上");
        }
      });
      if (!canMove) {
        this.coordinatesList.bottom.forEach((e, i) => {
          if (
            e.x1 < curCoordinate.pageX &&
            e.x2 > curCoordinate.pageX &&
            e.y1 < curCoordinate.pageY &&
            e.y2 > curCoordinate.pageY
          ) {
            canMove = true;
            this.from = 1;
            this.startIndex = i;
            console.log("下");
          }
        });
      }

      if (canMove) {
        this.isMoving = true;
        this.mousedown([this.from, this.startIndex]);
      }
    },

    touchmove(e) {
      // console.log(this.isMoving);
      if (this.isMoving) {
        // console.log(e.touches[0]);
        let curCoordinate = e.touches[0];
        this.moveX = curCoordinate.pageX;
        this.moveY = curCoordinate.pageY;
      }
    },
    touchend() {
      this.endIndex = -1;
      this.endFrom = -1;
      this.coordinatesList.top.forEach((e, i) => {
        if (
          e.x1 < this.moveX &&
          e.x2 > this.moveX &&
          e.y1 < this.moveY &&
          e.y2 > this.moveY
        ) {
          this.endIndex = i;
          this.endFrom = 0;
        }
      });
      this.coordinatesList.bottom.forEach((e, i) => {
        if (
          e.x1 < this.moveX &&
          e.x2 > this.moveX &&
          e.y1 < this.moveY &&
          e.y2 > this.moveY
        ) {
          this.endIndex = i;
          this.endFrom = 1;
        }
      });

      if (this.endIndex > -1) {
        if (this.isMoving) {
          this.isMoving = false;
          console.log("over");
          console.log(this.endIndex, this.endFrom);
          if (this.from != this.endFrom) {
            console.log([this.endFrom, this.endIndex]);
            this.mouseup([this.endFrom, this.endIndex]);
          }
        } else {
          console.log(123123);
        }
      }
    },

    mousedown(v1) {
      console.log(v1);
      this.clickItem = true;
      this.curFromOrigin = v1[0]; // 0 上, 1 下
      let index = -1;
      if (this.curFromOrigin == 0) {
        // 上边 开始
        this.currentDraw.drawFrom = v1;
        this.currentDraw.start.x =
          this.currentDraw.drawFrom[1] * JIAN_XI_H +
          this.itemWidth / 2 +
          this.itemWidth * this.currentDraw.drawFrom[1];
        this.currentDraw.startIndex = v1[1];
        this.currentDraw.start.y = ITEM_HEIGHT;

        this.drawList.forEach((e, i) => {
          if (e.startIndex == v1[1]) {
            index = i;
          }
        });
        if (index > -1) {
          let arr = this.drawList.filter((e, i) => i != index);
          this.drawList = [].concat(arr);
          this.repainCanvas();
        }
      } else if (this.curFromOrigin == 1) {
        // 下边 开始
        this.currentDraw.drawTo = v1;
        this.currentDraw.end.x =
          this.currentDraw.drawTo[1] * JIAN_XI_H +
          this.itemWidth / 2 +
          this.itemWidth * this.currentDraw.drawTo[1];
        this.currentDraw.endIndex = v1[1];
        this.currentDraw.end.y = JIAN_XI_V + ITEM_HEIGHT;

        this.drawList.forEach((e, i) => {
          if (e.endIndex == v1[1]) {
            index = i;
          }
        });
        if (index > -1) {
          let arr = this.drawList.filter((e, i) => i != index);
          this.drawList = [].concat(arr);
          this.repainCanvas();
        }
      }
    },
    mouseup(v1) {
      let index = -1;
      if (this.clickItem) {
        // console.log(v1);
        if (this.curFromOrigin != v1[0]) {
          // 0 上, 1 下
          if (v1[0] == 0) {
            // 上边 结束
            this.currentDraw.drawFrom = v1;
            this.currentDraw.start.x =
              this.currentDraw.drawFrom[1] * JIAN_XI_H +
              this.itemWidth / 2 +
              this.itemWidth * this.currentDraw.drawFrom[1];
            this.currentDraw.startIndex = v1[1];
            this.currentDraw.start.y = ITEM_HEIGHT;

            this.drawList.forEach((e, i) => {
              if (e.startIndex == v1[1]) {
                index = i;
              }
            });
            if (index > -1) {
              let arr = this.drawList.filter((e, i) => i != index);
              this.drawList = [].concat(arr);
              this.repainCanvas();
            }
          } else if (v1[0] == 1) {
            // 下边 结束
            this.currentDraw.drawTo = v1;
            this.currentDraw.end.x =
              this.currentDraw.drawTo[1] * JIAN_XI_H +
              this.itemWidth / 2 +
              this.itemWidth * this.currentDraw.drawTo[1];
            this.currentDraw.endIndex = v1[1];
            this.currentDraw.end.y = JIAN_XI_V + ITEM_HEIGHT;

            this.drawList.forEach((e, i) => {
              if (e.endIndex == v1[1]) {
                index = i;
              }
            });
            if (index > -1) {
              let arr = this.drawList.filter((e, i) => i != index);
              this.drawList = [].concat(arr);
              this.repainCanvas();
            }
          }

          this.drawList.push({
            startIndex: this.currentDraw.startIndex,
            endIndex: this.currentDraw.endIndex,
            points: [
              {
                x: this.currentDraw.start.x,
                y: this.currentDraw.start.y
              },
              {
                x: this.currentDraw.end.x,
                y: this.currentDraw.end.y
              }
            ]
          });
          console.log(this.drawList);
          this.drawList.forEach(e => {
            this.strockline(e.points);
          });
        } else {
          this.currentDraw.start.x = 0;
          this.currentDraw.start.y = 0;
          this.currentDraw.end.x = 0;
          this.currentDraw.end.y = 0;
          this.currentDraw.startIndex = -1;
          this.currentDraw.endIndex = -1;

          this.from = -1;
          this.endFrom = -1;
          this.startIndex = -1;
          this.endIndex = -1;
          this.isMoving = false;
        }
      }
    },
    init() {
      this.items = this.getElements(".matching-top .item");

      this.itemWidth = this.getElement(".matching-top .item").clientWidth;
      this.itemHeight = this.getElement(".matching-top .item").clientHeight;

      this.canvas = this.getElement("#backcanvas");
      this.context = this.canvas.getContext("2d");
      this.box = this.getElement("#matching");

      // 初始化 容器宽度
      this.box.style.width =
        this.items.length * this.itemWidth +
        (this.items.length - 1) * JIAN_XI_H +
        "px";

      this.initCoordinateInterval();
      this.initCanves();
    },

    // 移动端 初始化 坐标 区间
    initCoordinateInterval() {
      this.coordinatesList = {
        top: [],
        bottom: []
      };
      // console.log(this.box.getBoundingClientRect());
      let boxData = this.box.getBoundingClientRect();

      for (let index = 0; index < this.items.length; index++) {
        this.coordinatesList.top.push({
          x1: boxData.left + this.itemWidth * index + JIAN_XI_H * index,
          x2: boxData.left + this.itemWidth * (index + 1) + JIAN_XI_H * index,
          y1: boxData.top,
          y2: boxData.top + this.itemHeight
        });
        this.coordinatesList.bottom.push({
          x1: boxData.left + this.itemWidth * index + JIAN_XI_H * index,
          x2: boxData.left + this.itemWidth * (index + 1) + JIAN_XI_H * index,
          y1: boxData.top + JIAN_XI_V + this.itemHeight,
          y2: boxData.top + JIAN_XI_V + this.itemHeight * 2
        });
      }
      // console.log(this.coordinatesList);
    },

    // 整个画布清除
    clearCanvas() {
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    },

    getElement(className) {
      return document.querySelector(className);
    },
    getElements(classNames) {
      return document.querySelectorAll(classNames);
    },
    initCanves() {
      this.canvas.width = this.box.clientWidth;
      this.canvas.height = this.box.clientHeight;
    },

    // var lastX,lastY;//存放遍历坐标
    strockline(arr) {
      //绘制方法
      this.context.save();
      this.context.beginPath();
      this.context.lineWidth = 2;
      var lastX, lastY, lastX1, lastY1;
      lastX = arr[0].x;
      lastY = arr[0].y;
      lastX1 = arr[1].x;
      lastY1 = arr[1].y;

      this.context.moveTo(lastX, lastY);
      this.context.lineTo(lastX1, lastY1);
      this.context.stroke();
      this.context.restore();
    }
  }
};
</script>
<style lang="less" scoped>
.review-maps {
  padding-top: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
#matching {
  position: relative;
  -webkit-user-select: none;
  .matching-content {
    position: relative;
    z-index: 5;
  }
  .matching-gap {
    height: 200px;
  }
  .marching-item {
    display: flex;
    align-items: center;
    .item {
      width: 200px;
      height: 70px;
      margin-right: 35px;
      background-color: pink;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}

#backcanvas {
  top: 0;
  left: 0;
  position: absolute;
  // background-color: red;
  z-index: 1;
}
</style>
